import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { Moods } from '../components/participants/mood/moods';

@Injectable({
  providedIn: 'root'
})
export class MoodService {
  apiUrl = environment.apiUrl

  httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,private _authservice:AuthService) { }

  getAllMoods():Observable<any>
  {
    const token = this._authservice.getAuthToken();
		const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });   
    return this.http.get<any[]>(this.apiUrl+'mood/participant/getAllMoods',{headers:headers})
  }

  registerMood(mood:Moods):Observable<any>
  {
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.post<any[]>(this.apiUrl+'mood/participant/registerMood',mood,{headers:headers})
  }

  getRegisteredMoods():Observable<any>{
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get<any[]>(this.apiUrl+'mood/participant/getRegisteredMoodsByUserId',{headers:headers})
  }

  isMoodRegisteredForToday():Observable<any>{
    const token = this._authservice.getAuthToken();
    const headers = new HttpHeaders({ 'Authorization': 'Bearer ' + token });
    return this.http.get<any[]>(this.apiUrl+'mood/participant/isMoodRegisteredForToday',{headers:headers})
  }
}
